import {
	GET_SSID_SCHEDULER,
	GET_SSID_SCHEDULER_SUCCESS,
	GET_SSID_SCHEDULER_FAIL,
	ADD_SSID_SCHEDULE,
	EDIT_SSID_SCHEDULE,
	EDIT_SSID_SCHEDULE_SUCCESS,
	EDIT_SSID_SCHEDULE_FAIL,
	RESET_SSID_SCHEDULE,
	ADD_SSID_SCHEDULE_REQUEST,
	ADD_SSID_SCHEDULE_SUCCESS,
	ADD_SSID_SCHEDULE_FAIL,
	RESET_SSID_SCHEDULE_ADD,
} from '../../constants/globalProfileConstants/ssidSchedularConstants';

/**
 * Reducer function for managing SSID scheduler list state.
 *
 * This reducer handles actions related to fetching SSID scheduler data.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the SSID schedulerl list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const ssidSchedulerListReducer = (
	state = { ssidSchedulerList: {}, addSSIDSchedule: false },
	action
) => {
	switch (action.type) {
		case GET_SSID_SCHEDULER:
			return {
				loading: true,
			};
		case GET_SSID_SCHEDULER_SUCCESS:
			return {
				loading: false,
				ssidSchedulerList: action.payload,
			};
		case GET_SSID_SCHEDULER_FAIL:
			return {
				loading: false,
				error: action.payload,
			};
		case ADD_SSID_SCHEDULE:
			return {
				...state,
				addSSIDSchedule: action.payload,
			};
		default:
			return state;
	}
};

export const ssidScheduleEditReducer = (
	state = { editSSIDScheduleError: null, successMessage: '' },
	action
) => {
	switch (action.type) {
		case EDIT_SSID_SCHEDULE:
			return {
				...state,
				loadingEdit: true,
			};
		case EDIT_SSID_SCHEDULE_SUCCESS:
			return {
				...state,
				loadingEdit: false,
				successMessage: action.successMessage,
			};
		case EDIT_SSID_SCHEDULE_FAIL:
			return {
				...state,
				loadingEdit: false,
				editSSIDScheduleError: action.payload,
			};
		case RESET_SSID_SCHEDULE:
			return {
				...state,
				loadingEdit: false,
				successMessage: null,
				editSSIDScheduleError: null,
			};

		default:
			return state;
	}
};

export const ssidScheduleAddReducer = (
	state = {
		addSSIDScheduleError: null,
		addSSIDScheduleSuccess: null,
		addData: null,
		loadingAdd: false,
	},
	action
) => {
	switch (action.type) {
		case ADD_SSID_SCHEDULE_REQUEST:
			return {
				...state,
				loadingAdd: true,
			};
		case ADD_SSID_SCHEDULE_SUCCESS:
			return {
				...state,
				loadingAdd: false,
				addSSIDScheduleSuccess: action.payload,
			};
		case ADD_SSID_SCHEDULE_FAIL:
			return {
				...state,
				loadingAdd: false,
				addSSIDScheduleError: action.payload,
			};
		case RESET_SSID_SCHEDULE_ADD:
			return {
				...state,
				loadingAdd: false,
				addSSIDScheduleError: null,
				addSSIDScheduleSuccess: null,
				addData: null,
			};

		default:
			return state;
	}
};
